"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSubjectQuantityDiscount;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _pipe3 = _interopRequireDefault(require("lodash/fp/pipe"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _calcPercentDiscountPrice = _interopRequireDefault(require("../utils/calcPercentDiscountPrice"));

var _createSubjectDiscounts = _interopRequireDefault(require("../createSubjectDiscounts"));

function mapSubjectQuantityDiscount(_x, _x2, _x3, _x4, _x5) {
  return _mapSubjectQuantityDiscount.apply(this, arguments);
}

function _mapSubjectQuantityDiscount() {
  _mapSubjectQuantityDiscount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, rule, subject, settings, discountProduct) {
    var stngs, prevPrice, quantity, _pipe, _pipe2, discount, nextPrice;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            (0, _invariant.default)(settings && (typeof settings === 'string' || Array.isArray(settings[0])), 'mapSubjectQuantityDiscount requires settings to be type of `string` or list of `tuples`.');
            stngs = typeof settings === 'string' ? (0, _get.default)(settings, subject) : settings;

            if (stngs) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", null);

          case 4:
            prevPrice = subject.price, quantity = subject.quantity; // quantity in ranges

            _pipe = (0, _pipe3.default)(function (s) {
              return s.reduce(function (ret, _ref) {
                var _ref2 = (0, _toArray2.default)(_ref),
                    fr = _ref2[0],
                    to = _ref2[1],
                    st = _ref2.slice(2);

                return (fr || 1) <= quantity && quantity < (to || Number.MAX_SAFE_INTEGER) ? st : ret;
              }, []);
            }, (0, _cond.default)([[function (_ref3) {
              var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
                  d = _ref4[0],
                  _ref4$ = _ref4[1],
                  t = _ref4$ === void 0 ? 'percentDiscount' : _ref4$;

              return d && t === 'percentDiscount';
            }, function (_ref5) {
              var _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
                  d = _ref6[0];

              return [d, (0, _calcPercentDiscountPrice.default)(prevPrice, d)];
            }], [function (_ref7) {
              var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
                  t = _ref8[1];

              return t === 'fixedPrice';
            }, function (_ref9) {
              var _ref10 = (0, _slicedToArray2.default)(_ref9, 1),
                  d = _ref10[0];

              return [d, d];
            }], [function () {
              return true;
            }, function () {
              return [null, prevPrice];
            }]]))(stngs), _pipe2 = (0, _slicedToArray2.default)(_pipe, 2), discount = _pipe2[0], nextPrice = _pipe2[1];

            if (!discount) {
              _context.next = 15;
              break;
            }

            _context.t1 = _extends2.default;
            _context.t2 = {
              price: nextPrice
            };
            _context.next = 11;
            return (0, _createSubjectDiscounts.default)(ctx, rule, discountProduct, nextPrice - prevPrice, quantity);

          case 11:
            _context.t3 = _context.sent;
            _context.t0 = (0, _context.t1)(_context.t2, _context.t3);
            _context.next = 16;
            break;

          case 15:
            _context.t0 = null;

          case 16:
            return _context.abrupt("return", _context.t0);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mapSubjectQuantityDiscount.apply(this, arguments);
}